import isScrollTargetVisible from '../00-utilities/isScrollTargetVisible';
import {debounce} from 'underwater';


export default class Marquee {
  constructor(opts) {
    this.setOptions(opts);
    if(document.querySelector(this.options.selector)) {
      this.setStates();
      this.preBuild();
      this.allImagesAreLoaded();
    }
  }

  setOptions(opts) {
    this.options = {
      selector : opts.selector,
      direction : opts.direction || 'right',
    };
  }

  setStates() {
    this.states = {
      position: 0,
      loaded: false,
    }
  }

  preBuild() {

    this.self = document.querySelector(this.options.selector);
    let marquee;
    if(!this.self) {
      console.error(this.options.selector + ' is not defined, ' + this.self + ' not found');
    }

    marquee = this.self.querySelector('.marquee__list');

    if( !marquee) {
      console.error(this.options.selector + '.marquee__list is not defined, marquee__list not found');
    }

    if(this.self.querySelector('[data-lazy-src]')) {
      this.addLocalOverlay();
      if(isScrollTargetVisible(this.options.selector)) {
        this.loadImages();
      }
      else {
        this.onLoadTrigger = debounce(this.onScroll.bind(this),100);
        window.addEventListener('scroll',this.onLoadTrigger);
      }
    }
  }


  build() {
    this.setHeight();
    this.addClones();
    this.play();
  }


  setHeight() {
    let height = 0;

    Array.from(this.self.querySelectorAll('.marquee__img'))
    .forEach((img)=>{ height = height < img.offsetHeight ? img.offsetHeight : height;})
    this.self.style.height = height + 'px';
  }

  addClones() {
    this.margin = parseFloat(window.getComputedStyle(this.self.querySelectorAll('.marquee__item')[1]).getPropertyValue('margin-left'));
    let width = 0;
    let clonesNumber;
    let clones = [];
    Array.from(this.self.querySelectorAll('.marquee__item')).forEach((image)=>{
      width += image.offsetWidth;
    })

    if(width > this.self.offsetWidth) {
      clonesNumber = 1;
    }
    else {
      clonesNumber = Math.ceil(this.self.offsetWidth / width);
    }

    for(let ii = 1; ii <= clonesNumber; ii++ ) {
      clones[ii] = this.self.querySelector('.marquee__list').cloneNode(true);


        if(this.options.direction == 'left') {
        this.self.insertBefore(clones[ii], null).style.left = (this.self.querySelector('.marquee__list').offsetWidth + this.margin) + 'px';
          if(clonesNumber > 1) {
            this.self.insertBefore(clones[ii].cloneNode('true'), this.self.querySelector('.marquee__list'));
            this.self.querySelector('.marquee__list').style.left = -((this.self.querySelector('.marquee__list').offsetWidth * ii) + this.margin)  + 'px';
          }
        }

        else if(this.options.direction == 'right') {
          this.self.insertBefore(clones[ii], this.self.querySelector('.marquee__list'));
          this.self.querySelector('.marquee__list').style.left = -((this.self.querySelector('.marquee__list').offsetWidth * ii) + this.margin)  + 'px';

          if(clonesNumber > 1) {
            this.self.insertBefore(clones[ii].cloneNode('true'), this.self.querySelector('.marquee__list'));
            this.self.querySelector('.marquee__list').style.left = ((this.self.querySelector('.marquee__list').offsetWidth * ii) + this.margin)  + 'px';
          }
        }


    }

  }
  goLeft() {
    this.states.position -= 1;
  }

  goRight() {
    this.states.position += 1;
  }

  render() {
    Array.from(this.self.querySelectorAll('.marquee__list'))
    .forEach((list) => {list.style.transform = `translate3d(${this.states.position}px,0,0)`});
  }

  play() {
    if(this.options.direction == "left") {
      this.goLeft();
    }
    else if(this.options.direction == "right") {
      this.goRight();
    }
    this.rewind();
    this.render();
    requestAnimationFrame(this.play.bind(this));
  }

  rewind() {
    if(this.options.direction == "left" && this.self.querySelector('.marquee__list').offsetWidth < Math.abs(this.states.position)) {
      this.states.position = 0 + this.margin;
    }

    else if(this.options.direction == "right" && this.self.querySelector('.marquee__list').offsetWidth < Math.abs(this.states.position)) {
      this.states.position = 0 - this.margin;
    }
  }


  addLocalOverlay() {
    this.overlay = document.createElement('div');
    this.overlay.style.position = "absolute";
    this.overlay.style.top ="0";
    this.overlay.style.left ="0";
    this.overlay.style.right ="0";
    this.overlay.style.bottom ="0";
    this.overlay.style.backgroundColor= 'rgba(255,255,255,.9)';
    this.overlay.style.zIndex= "1";
    this.self.appendChild(this.overlay);
  }

  removeLocalOverlay() {
    if(this.overlay) {
      this.overlay.parentElement.removeChild(this.overlay);
      this.overlay = null;

    }
  }

  onScroll() {
    if(isScrollTargetVisible(this.options.selector)) {
      this.loadImages();
      window.removeEventListener('scroll',this.onLoadTrigger);
    }
  }

  loadImages(){
    let images = Array.from(this.self.querySelectorAll('.marquee__img'));

    images.forEach((image)=>{
      image.src = image.getAttribute('data-lazy-src');
    })
  }

  allImagesAreLoaded() {
    let images = Array.from(this.self.querySelectorAll('.marquee__img'));

    images.forEach((image)=> {
      image.addEventListener('load',()=>{
        let pass = true;
        // Check if all images are completed
        images.forEach((image)=>{
          if (pass) {
            pass = image.complete;
          }
        })

        // Check if marquees are not loaded , load them
        if(pass && !this.states.loaded) {
          this.states.loaded = true;
          this.removeLocalOverlay()
          this.build();
        }
      })
    });
  }
}
